import React from 'react';
import { useAppContext } from 'providers/AppProvider';
import { useTranslation } from 'react-i18next';

const Home = () => {
  const {
    config: { isDark },
  } = useAppContext();
  const { t } = useTranslation();

  return (
    <div className="home-page" data-bs-theme={isDark ? 'dark' : 'light'}>
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-12">
            <div
              className="text-center py-5"
              style={{ color: isDark ? '#e2e8f0' : '#212529' }}
            >
              <h1 className="display-4 mb-4">{t('welcome')}</h1>
              <p className="lead">{t('dashboard')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
